<template>
  <div class="m-pc-content" v-html="content" ref="contentContainer"></div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
import { videoProtectionMixin } from "../mixin/videoProtection";

export default {
  name: "Content",
  mixins: [videoProtectionMixin],
  data() {
    return {
      content: ""
    };
  },
  created() {
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.content = info.content;
        // 内容更新后处理video标签
        this.handleContentUpdate();
      }
    });
  },
  components: {}
};
</script>
